export const BASE_APP_URL = '/apps/';

/** Masked value displayed in place of sensitive fields (API keys, tokens, etc.). */
export const MASKED_VALUE = '******';
